<template>
  <div class="video-wrapper">
    <VideoPlayer
      autoplay
      loop
      muted
      playsinline
      :posters="[
        {
          src: '/videos/background.jpg',
          media: '(min-width: 768px)'
        },
        {
          src: '/videos/background-mobile.jpg',
          media: '(max-width: 767px)'
        }
      ]"
      :sources="[
        {
          src: '/videos/background.webm',
          type: 'video/webm',
          media: '(min-width: 768px)'
        },
        {
          src: '/videos/background.mp4',
          type: 'video/mp4',
          media: '(min-width: 768px)'
        },
        {
          src: '/videos/background-mobile.webm',
          type: 'video/webm',
          media: '(max-width: 767px)'
        },
        {
          src: '/videos/background-mobile.mp4',
          type: 'video/mp4',
          media: '(max-width: 767px)'
        }
      ]"
    />
  </div>

  <div class="absolute min-h-screen flex flex-col items-center justify-center w-full py-6 px-6 sm:px-12">
    <div class="login-box flex flex-col gap-y-12 text-gray-100 px-6 sm:px-14 py-16 rounded-xl">
      <img
        :src="asset('images/logo-vrt.svg')"
        width="187"
        height="207"
        class="login-logo self-center"
        alt="Salve"
      />
      <slot />
    </div>
  </div>
</template>

<style scoped>
.login-logo {
  width: 147px;
  height: 162px;
  @screen md {
    width: 187px;
    height: 207px;
  }
}
.login-box {
  @apply w-full;
  @screen sm {
    max-width: 512px;
  }
}
.video-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  video {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}
</style>

<script setup>
import VideoPlayer from '@/Components/Video/VideoPlayer.vue'
</script>

<script>
import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue'
import { Link } from '@inertiajs/vue3'

export default {
  components: {
    BreezeApplicationLogo,
    Link
  }
}
</script>
